<template>
    <div>
        <the-banner :title="this.$lang.blogTitle"
                    :description="this.$lang.blogSubtitle"
                    image="cover.jpeg"/>
        <div id="feed-container"
             :class="{'body-block': true,
                      'uninitialized': !initialized}">
            <div v-for="(col, x) in this.cols"
                 :key="x"
                 class="col"
                 :ref="`col-${x}`">
                <post v-for="(post, index) in col"
                      class="post"
                      :key="index"
                      :data="post"/>
            </div>
        </div>
        <div class="loading-controls">
            <div v-if="exhausted">{{this.$lang.blogNoMore}}</div>
            <div v-if="loading">{{this.$lang.loading}}</div>
            <div v-if="!loading && !exhausted"
                 id="btn-load-more"
                 class="button"
                 @click="loadMorePosts">
                {{this.$lang.blogLoadMore}}
            </div>
        </div>
    </div>
</template>

<script>
	import Post from "@/components/Post";
	import TheBanner from "@/components/TheBanner";
	import FeedService from "@/services/FeedService";

	export default {
		name: "Blog",
		components: {TheBanner, Post},
		mounted() {
			window.addEventListener("resize", this.updateColCount);
			this.updateColCount();
			setTimeout(this.loadMorePosts, 1000);
		},
		destroyed() {
			window.removeEventListener("resize", this.updateColCount);
		},
		data() {
			return {
				posts: [],
				loading: true,
				exhausted: false,
				retCount: 10,
				initialized: false,
				cols: [[]]
			}
		},
		methods: {
			loadMorePosts() {
				this.loading = true;
				FeedService.getPosts(this.posts.length).then(result => {
					this.posts = this.posts.concat(result);
					this.add(result);
					this.loading = false;
					this.initialized = true;
					if (result.length < this.retCount) {
						this.exhausted = true;
					}
				});
			},
			updateColCount() {
				let newColCount = Math.floor(Math.min(window.innerWidth, 1200) / 400);
				if (newColCount !== this.cols.length) {
					this.cols = [[]];
					for (let x = 1; x < newColCount; x++) {
						this.cols.push([]);
					}
					setImmediate(() => {
						this.add(this.posts);
                    });
				}
			},
			addSingle(post) {
				let minHeight = 99999, target = 0;
				for (let col = 0; col < this.cols.length; col++) {
					let colHeight = this.$refs[`col-${col}`][0].clientHeight;
					if (colHeight < minHeight) {
						target = col;
						minHeight = colHeight;
					}
				}
				this.cols[target].push(post);
				return new Promise(resolve => {
					setInterval(resolve, 50);
				});
			},
			async add(posts) {
				for (let post of posts) {
					await this.addSingle(post);
				}
			}
		}
	}
</script>

<style scoped lang="scss">
    #feed-container {
        display: flex;
        position: relative;
        flex-direction: row;

        @media #{$tablet} {
            margin-top: 16px;
        }

        @media #{$tablet-inv} {
            margin-top: 48px;
        }

        min-height: 500px;
    }

    #feed-container.uninitialized {
        display: none;
    }

    .col {
        flex-grow: 1;
        flex-basis: 0;
        align-self: flex-start;
        width: 0;

        @media #{$tablet-inv} {
            margin: 8px;
        }
    }

    .post {
        margin: 16px 0;
    }

    .loading-controls {
        width: 90%;
        max-width: 300px;
        margin: 32px auto 0 auto;
        text-align: center;
    }

    .loading-controls > div {
        height: 52px;
        box-sizing: border-box;
    }
</style>